// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6565ac3b","940":"7937d50e"}[chunkId] + ".chunk.js";
};